// 需要全局注册的自定义指令
import hmt from './hmt'

const directives = {
  hmt // 百度统计
}

export default {
  install(Vue) {
    Object.keys(directives).forEach((key) => {
      Vue.directive(key, directives[key])
    })
  }
}
